module.exports = __webpack_public_path__ + "img/multipart-toggle.4a234ada.svg";